import script from "./ingredient-row.vue?vue&type=script&setup=true&lang=js"
export * from "./ingredient-row.vue?vue&type=script&setup=true&lang=js"

import "./ingredient-row.vue?vue&type=style&index=0&id=4b33339e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b33339e"]])

export default __exports__